/// <amd-module name="VSSUI/MessageCard" />
export { MessageCard } from "./Components/MessageCard/MessageCard";
export { IMessageCardProps } from "./Components/MessageCard/MessageCard.Props";
export { MessageCardSeverity } from "./Components/MessageCard/MessageCard.Props";
